module.exports = __webpack_public_path__ + "img/alias.6e4e4e1e.svg";